export enum PickerDisplay {
    Category = 'category',
    None = 'none',
    Template = 'template',
}
